"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _errorActions = require("../error/errorActions");
var _appActions = require("../appActions");
var _upsellActions = require("../upsell/upsellActions");
var _uiActions = require("./uiActions");
var _constants = require("../../utils/constants");
var _questionnaireActions = require("../questionnaire/questionnaireActions");
var _recommendationActions = require("../recommendation/recommendationActions");
const initialState = {
  isLoading: false,
  loaderText: '',
  isGuidedSellingModalOpen: false,
  isFloaterOpen: false,
  currentPage: _constants.PAGES.QUESTIONNAIRE,
  error: '',
  isCheckoutInProgress: false,
  timestamps: [],
  journrySteps: [],
  currentModalSize: 'md',
  currentDynamicPage: '',
  PrevPage: _constants.PAGES.QUESTIONNAIRE
};
const uiReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  switch (type) {
    case _uiActions.LOADING:
      return {
        ...state,
        isLoading: payload.isLoading,
        loaderText: !payload.isLoading ? '' : state.loaderText
      };
    case _uiActions.UPDATE_LOADER_TEXT:
      return {
        ...state,
        loaderText: payload.loaderText
      };
    case _questionnaireActions.END_QUESTIONNAIRE:
      return {
        ...state,
        currentPage: _constants.PAGES.SUMMARY
      };
    case _recommendationActions.GO_BACK_TO_CURRENT_QUESTION:
    case _recommendationActions.GO_BACK_TO_QUESTIONNAIRE:
      return {
        ...state,
        currentPage: _constants.PAGES.QUESTIONNAIRE
      };
    case _upsellActions.GO_BACK_TO_RECOMMENDATION:
      return {
        ...state,
        currentPage: _constants.PAGES.RECOMMENDATION
      };
    case _recommendationActions.GO_TO_UPSELL_PAGE:
      return {
        ...state,
        currentPage: _constants.PAGES.UPSELL
      };
    case _recommendationActions.GO_TO_COMPARISON_PAGE:
      return {
        ...state,
        currentPage: _constants.PAGES.COMPARISON
      };
    case _uiActions.GO_TO_DYNAMIC_PAGE:
      return {
        ...state,
        currentPage: _constants.PAGES.DYNAMIC
      };
    case _questionnaireActions.END_SUMMARY:
      return {
        ...state,
        currentPage: _constants.PAGES.RECOMMENDATION
      };
    case _uiActions.SET_DYNAMIC_PAGE_CONTENT:
      return {
        ...state,
        currentDynamicPage: payload.contentKey
      };
    case _uiActions.OPEN_GUIDED_SELLING_MODAL:
      return {
        ...state,
        isGuidedSellingModalOpen: true
      };
    case _uiActions.CLOSE_GUIDED_SELLING_MODAL:
      return {
        ...state,
        isGuidedSellingModalOpen: false
      };
    case _appActions.INJECT_STATE:
      {
        var _payload$questionnair;
        if (((_payload$questionnair = payload.questionnaire) === null || _payload$questionnair === void 0 ? void 0 : _payload$questionnair.currentQuestionIndex) === _constants.RECOMMENDATION_PAGE_INDEX) {
          return {
            ...state,
            currentPage: _constants.PAGES.RECOMMENDATION,
            timestamps: payload.timestamps || []
          };
        }
        return {
          ...state,
          timestamps: payload.timestamps || []
        };
      }
    case _errorActions.API_CALL_ERROR:
      return {
        ...state,
        currentPage: _constants.PAGES.ERROR
      };
    case _errorActions.API_CALL_RETRY_SUCCESS:
      return {
        ...state,
        currentPage: payload.page
      };
    case _appActions.CHECKOUT:
      return {
        ...state,
        isCheckoutInProgress: true
      };
    case _appActions.CHECKOUT_ERROR:
    case _appActions.CHECKOUT_SUCCESS:
      return {
        ...state,
        isCheckoutInProgress: false
      };
    case _questionnaireActions.RESET_QUESTIONNAIRE:
      return {
        ...state,
        currentPage: _constants.PAGES.QUESTIONNAIRE
      };
    case _uiActions.UPDATE_TIME_STAMP:
      return {
        ...state,
        timestamps: [...state.timestamps.filter(timestamp => payload.findIndex(el => el.id === timestamp.id) === -1), ...payload]
      };
    case _uiActions.SET_MODAL_SIZE:
      return {
        ...state,
        currentModalSize: payload.size
      };
    case _uiActions.SET_PREV_PAGE:
      return {
        ...state,
        PrevPage: payload
      };
    case _uiActions.GO_TO_RECOMMENDATION_ERROR_PAGE:
      return {
        ...state,
        currentPage: _constants.PAGES.RECOMMENDATION_ERROR
      };
    case _uiActions.OPEN_FLOATER:
      return {
        ...state,
        isFloaterOpen: true
      };
    case _uiActions.CLOSE_FLOATER:
      return {
        ...state,
        isFloaterOpen: false
      };
    case _uiActions.SET_ICON:
      return {
        ...state,
        icons: payload
      };
    case _uiActions.SET_STEPPER_STEPS:
      return {
        ...state,
        journrySteps: payload.journrySteps
      };
    default:
      return state;
  }
};
var _default = uiReducer;
exports.default = _default;